import { render, staticRenderFns } from "./earthquakeEarlyWarningFile.vue?vue&type=template&id=631e3c0b&scoped=true"
import script from "./earthquakeEarlyWarningFile.vue?vue&type=script&lang=js"
export * from "./earthquakeEarlyWarningFile.vue?vue&type=script&lang=js"
import style0 from "./earthquakeEarlyWarningFile.vue?vue&type=style&index=0&id=631e3c0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631e3c0b",
  null
  
)

export default component.exports